import Grid from '@mui/material/Grid';
//import DisclaimerCard from './DisclaimerCard';



export default function SectionDisclaimer({disclaimer}) {

    
    return (

        <>

        <Grid container sx={{p: {sm:'1em'}, width: '100%'}}>
            
                <Grid size={{xs:12}} display='flex' justifyContent={{xs:'center'}} alignItems='center' sx={{ p:{xs: '2em', lg: '4em',}, }}> 
                         
                           {disclaimer}
                </Grid>
        
            </Grid>
        
        </>
    )
}